var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { useEffect, useMemo, useState } from 'react';
import { Button, Col, DatePicker, Form, Input, Modal, Row, Switch, Upload } from 'antd';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { DEFAULT_FORM_VALUES } from '../contants/option';
dayjs.extend(utc);
dayjs.extend(timezone);
const JAPAN_TIMEZONE = 'Asia/Tokyo';
const toDateTimeValue = value => value ? dayjs(value).tz(JAPAN_TIMEZONE) : null;
const toApiDateTimeValue = value => value ? `${value.format('YYYY-MM-DDTHH:mm:ss')}+09:00` : '';
const buildUploadFileList = file => file ? [{
        uid: '-1',
        name: file.name,
        status: 'done'
    }] : [];
export default function BannerFormModal({ open, editingBanner, loading = false, getCreateSortOrder, onCancel, onSubmit }) {
    var _a;
    const _Form$useForm = Form.useForm(), _Form$useForm2 = _slicedToArray(_Form$useForm, 1), form = _Form$useForm2[0];
    const _useState = useState(null), _useState2 = _slicedToArray(_useState, 2), selectedImageFile = _useState2[0], setSelectedImageFile = _useState2[1];
    const _useState3 = useState(null), _useState4 = _slicedToArray(_useState3, 2), selectedVideoFile = _useState4[0], setSelectedVideoFile = _useState4[1];
    useEffect(() => {
        if (!open)
            return;
        if (editingBanner) {
            form.setFieldsValue({
                title: editingBanner.title || '',
                mediaType: editingBanner.media_type,
                imageLinkUrl: editingBanner.image_link_url || '',
                videoLinkUrl: editingBanner.video_link_url || '',
                position: 2,
                startDate: toDateTimeValue(editingBanner.start_date),
                endDate: toDateTimeValue(editingBanner.end_date),
                active: editingBanner.active
            });
        }
        else {
            form.setFieldsValue(DEFAULT_FORM_VALUES);
        }
        form.setFieldValue('bannerImage', undefined);
        setSelectedImageFile(null);
        setSelectedVideoFile(null);
    }, [open, editingBanner, form]);
    const selectedMediaType = (_a = Form.useWatch('mediaType', form)) !== null && _a !== void 0 ? _a : 'image';
    const selectedStartDate = Form.useWatch('startDate', form);
    const imageUploadFileList = useMemo(() => buildUploadFileList(selectedImageFile), [selectedImageFile]);
    const videoUploadFileList = useMemo(() => buildUploadFileList(selectedVideoFile), [selectedVideoFile]);
    const disablePastStartDate = current => current.isBefore(dayjs().startOf('day'));
    const disableInvalidEndDate = current => {
        if (current.isBefore(dayjs().startOf('day')))
            return true;
        if (!selectedStartDate)
            return false;
        return current.isBefore(selectedStartDate.startOf('day'));
    };
    const handleOk = () => __awaiter(this, void 0, void 0, function* () {
        var _a;
        const values = yield form.validateFields();
        const isImageBanner = true;
        const isCreate = !editingBanner;
        const payload = {
            title: values.title,
            media_type: 'image',
            position: 2,
            start_date: toApiDateTimeValue(values.startDate),
            end_date: toApiDateTimeValue(values.endDate),
            sort_order: (_a = editingBanner === null || editingBanner === void 0 ? void 0 : editingBanner.sort_order) !== null && _a !== void 0 ? _a : getCreateSortOrder(),
            active: values.active,
            image_link_url: values.imageLinkUrl || '',
            video_link_url: values.videoLinkUrl || '',
            banner_image: isImageBanner ? selectedImageFile || undefined : undefined,
            banner_video: isImageBanner ? undefined : selectedVideoFile || undefined
        };
        if (isCreate && !isImageBanner) {
            throw new Error('Please choose a video file.');
        }
        yield onSubmit(payload, {
            isCreate
        });
    });
    const handleClose = () => {
        form.resetFields();
        form.setFieldValue('bannerImage', undefined);
        setSelectedImageFile(null);
        setSelectedVideoFile(null);
        onCancel();
    };
    return /*#__PURE__*/ React.createElement(Modal, {
        open: open,
        title: editingBanner ? 'バナー編集' : 'バナー作成',
        onCancel: handleClose,
        onOk: handleOk,
        okText: editingBanner ? '更新' : '作成',
        cancelText: "\u30AD\u30E3\u30F3\u30BB\u30EB",
        confirmLoading: loading,
        destroyOnHidden: true,
        width: 760
    }, /*#__PURE__*/ React.createElement(Form, {
        form: form,
        layout: "vertical",
        initialValues: DEFAULT_FORM_VALUES
    }, /*#__PURE__*/ React.createElement(Form.Item, {
        label: "\u30BF\u30A4\u30C8\u30EB",
        name: "title",
        rules: [{
                required: true,
                message: 'タイトルを入力してください'
            }]
    }, /*#__PURE__*/ React.createElement(Input, {
        placeholder: "Spring campaign banner"
    })), /*#__PURE__*/ React.createElement(Form.Item, {
        label: "\u30EA\u30F3\u30AFURL",
        name: selectedMediaType === 'video' ? 'videoLinkUrl' : 'imageLinkUrl',
        rules: [{
                required: true,
                message: 'リンクURLを入力してください'
            }, {
                type: 'url',
                warningOnly: true,
                message: '有効なURLを入力してください'
            }]
    }, /*#__PURE__*/ React.createElement(Input, {
        placeholder: selectedMediaType === 'video' ? 'https://itonami.example.com/video-campaign' : 'https://itonami.example.com/image-campaign'
    })), /*#__PURE__*/ React.createElement(Row, {
        gutter: 16
    }, /*#__PURE__*/ React.createElement(Col, {
        span: 10
    }, /*#__PURE__*/ React.createElement(Form.Item, {
        label: "\u958B\u59CB\u65E5",
        name: "startDate"
    }, /*#__PURE__*/ React.createElement(DatePicker, {
        showTime: {
            format: 'HH:mm'
        },
        format: "YYYY-MM-DD HH:mm",
        className: "w-full",
        placeholder: "YYYY-MM-DD HH:mm",
        disabledDate: disablePastStartDate
    }))), /*#__PURE__*/ React.createElement(Col, {
        span: 10
    }, /*#__PURE__*/ React.createElement(Form.Item, {
        label: "\u7D42\u4E86\u65E5",
        name: "endDate"
    }, /*#__PURE__*/ React.createElement(DatePicker, {
        showTime: {
            format: 'HH:mm'
        },
        format: "YYYY-MM-DD HH:mm",
        className: "w-full",
        placeholder: "YYYY-MM-DD HH:mm",
        disabledDate: disableInvalidEndDate
    }))), /*#__PURE__*/ React.createElement(Col, {
        span: 4
    }, /*#__PURE__*/ React.createElement(Form.Item, {
        label: "\u30B9\u30C6\u30FC\u30BF\u30B9",
        name: "active",
        valuePropName: "checked"
    }, /*#__PURE__*/ React.createElement(Switch, null)))), /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 gap-4 md:grid-cols-2"
    }, /*#__PURE__*/ React.createElement(Form.Item, {
        label: "\u30B5\u30E0\u30CD\u30A4\u30EB\u753B\u50CF",
        name: "bannerImage",
        required: selectedMediaType === 'image' && !editingBanner,
        hidden: selectedMediaType !== 'image',
        rules: [{
                validator: () => __awaiter(this, void 0, void 0, function* () {
                    if (!editingBanner && selectedMediaType === 'image' && !selectedImageFile) {
                        throw new Error('サムネイル画像を選択してください');
                    }
                })
            }]
    }, /*#__PURE__*/ React.createElement(Upload, {
        beforeUpload: file => {
            form.setFieldValue('bannerImage', file.name);
            setSelectedImageFile(file);
            setSelectedVideoFile(null);
            return false;
        },
        onRemove: () => {
            form.setFieldValue('bannerImage', undefined);
            setSelectedImageFile(null);
        },
        maxCount: 1,
        fileList: imageUploadFileList,
        showUploadList: true
    }, /*#__PURE__*/ React.createElement(Button, null, "\u753B\u50CF\u3092\u9078\u629E")), (editingBanner === null || editingBanner === void 0 ? void 0 : editingBanner.image_url) && !selectedImageFile ? /*#__PURE__*/ React.createElement("img", {
        src: editingBanner.image_url,
        alt: "current banner",
        className: "mt-3 max-h-[120px] rounded-md border border-[#e5e7eb] object-cover"
    }) : null), /*#__PURE__*/ React.createElement(Form.Item, {
        label: editingBanner ? '動画を置き換える' : '動画アップロード',
        required: selectedMediaType === 'video' && !editingBanner,
        hidden: selectedMediaType !== 'video'
    }, /*#__PURE__*/ React.createElement(Upload, {
        beforeUpload: file => {
            setSelectedVideoFile(file);
            setSelectedImageFile(null);
            return false;
        },
        onRemove: () => {
            setSelectedVideoFile(null);
        },
        maxCount: 1,
        fileList: videoUploadFileList,
        showUploadList: true
    }, /*#__PURE__*/ React.createElement(Button, null, "\u52D5\u753B\u3092\u9078\u629E")), (editingBanner === null || editingBanner === void 0 ? void 0 : editingBanner.video_url) && !selectedVideoFile ? /*#__PURE__*/ React.createElement("video", {
        src: editingBanner.video_url,
        className: "mt-3 max-h-[120px] rounded-md border border-[#e5e7eb]",
        controls: true
    }) : null))));
}
